import type { RaftPartId } from "@eldrun/content";
import { h } from "../kit/dom.ts";
import { keyHint } from "./settings.ts";
import type { RaftRow } from "./raft-model.ts";

/**
 * Reparo da Jangada (doc 01): cada componente com a etapa e o que falta; "Depositar" entrega o que
 * você tiver do que falta (a barra é de todos). Pronta, "Zarpar" chama todo mundo para o convés.
 */
export class RaftPanel {
  readonly element: HTMLElement;
  private readonly list: HTMLElement;
  private readonly sail: HTMLButtonElement;
  private key = "";
  open = false;

  constructor(parent: HTMLElement, deposit: (part: RaftPartId) => void, sail: () => void) {
    this.list = h("div", { class: "craft-list" });
    this.sail = h("button", { class: "primary", onclick: () => sail() }, "Zarpar") as HTMLButtonElement;
    this.element = h(
      "section",
      { id: "jangada", class: "panel crafting trade", "aria-label": "Barco" },
      h("h2", {}, "Barco"),
      h("p", { class: "hint" }, "Depositar entrega o que você tiver do que falta; a barra é do grupo. O Altar se enche com as Gemas do Relicário."),
      this.list,
      this.sail,
      keyHint("interact", "{} fecha"),
    );
    this.element.hidden = true;
    this.list.addEventListener("click", (e) => {
      const button = (e.target as HTMLElement).closest("button[data-part]") as HTMLButtonElement | null;
      if (button?.dataset["part"]) deposit(button.dataset["part"] as RaftPartId);
    });
    parent.appendChild(this.element);
  }

  show(open: boolean): void {
    this.open = open;
    this.element.hidden = !open;
  }

  update(rows: readonly RaftRow[], ready: boolean): void {
    const key = JSON.stringify(rows) + ready;
    if (key === this.key) return;
    this.key = key;
    this.list.replaceChildren(
      ...rows.map((r) =>
        h(
          "div",
          { class: `craft-row${r.done ? " done" : ""}` },
          h("strong", {}, r.done ? `${r.name} · pronto` : `${r.name} · etapa ${r.stage}/${r.stages}`),
          h("span", { class: "hint" }, r.needs.map((n) => `${n.name} ${n.have}/${n.need}${n.owned > 0 && n.have < n.need ? ` (você tem ${n.owned})` : ""}`).join(" · ")),
          r.part === "altar" || r.done ? h("span", {}) : h("button", { class: "small", "data-part": r.part, disabled: !r.canDeposit }, "Depositar"),
        ),
      ),
    );
    this.sail.hidden = !ready;
  }

  remove(): void {
    this.element.remove();
  }
}
